import React, { useState, useEffect, useCallback } from "react";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import { APICall } from "../../../helpers/API/APICalls";
import {
  getAppVersionMasterDataById,
  insertUpdateAppVersionMaster,
} from "../../../helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { useHistory, useParams } from "react-router-dom";
import {
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
// import { FormLabel } from "@material-ui/core";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

const AppVersionMasterEdit = () => {
  let history = useHistory();
  // const { id: appId } = useParams();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeIsActive, setEditModeIsActive] = useState(true);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const [Id, setId] = useState(0);

  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  let formErrorObj = {};
  let state_id = 0;

  useEffect(() => {
    (async () => {
      state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      if (state_id !== 0 || state_id != "0") {
        getAppVersionMasterDataByIdApiCall(state_id);
      }
    })();
  }, []);

  const getAppVersionMasterDataByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(getAppVersionMasterDataById, { id: id }, "POST");

    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].Id) {
        setId(data.data[0][0].Id);
        setName(data.data[0][0].Name);
        setIsActive(data.data[0][0].IsActive);
        setEditModeIsActive(false);
        setEditModeDisableButton(false);
      }
      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };

  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x === undefined
      );
      if (isEmpty) {
        let creator = getFromEncLocalStorage("userId");
        setLoading(true);
        let requestParams = {
          Id: Id,
          Name: name.replace(/\s+/g, "").trim(), // changed
          UpdateType: "Force",
          IsActive: isActive,
          CreatedDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          UserId: creator,
        };
        const res = await APICall(
          insertUpdateAppVersionMaster,
          requestParams,
          "POST"
        );
        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            if (Id === 0) {
              notify(0, saveRecordMsg);
            } else if (Id > 0) {
              notify(0, updateRecordMsg);
            }
            history.push({ pathname: "/appversion-master" });
          }
          setLoading(false);
        } else {
          notify(1, res.message);
          setLoading(false);
        }
        setLoading(false);
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/appversion-master" });
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    setName("");
    formErrorObj = {};
  };

  const handleTextEvent = async (event, field) => {
    var error = undefined;
    let tempName = event.target.value;
    var setError = "";
    if (field === "name") {
      setName(tempName);
      setError = "AppVersion";
    }

    if (tempName == undefined || tempName == null || tempName.trim() == "") {
      error = setError + " Cannot Be Empty";
    } else if (
      tempName == undefined ||
      tempName == null ||
      /^[0-9]\d*/.test(tempName) == ""
    ) {
      error = setError + " Value Should be Numeric";
    } else if (/\s/g.test(tempName)) {
      error = "Value should be without space";
    }

    setFormErrors((preState) => ({
      ...preState,
      [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    }));
  };

  const checkValidations = async () => {
    var objError = {};
    var setError = "";

    if (name == undefined || name == null || name.trim() == "") {
      setError = "AppVersion";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Cannot Be Empty";
    } else if (name.replace(/\s+/g, " ").trim().length >= 50) {
      setError = "AppVersion";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Is Longer Than The 50 Character";
    } else if (
      name == undefined ||
      name == null ||
      /^(?:\d+(?:\.\d+)*|\d+)$/.test(name) == ""
    ) {
      setError = "AppVersion";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Value Should be Numeric";
    } else if (/\s/g.test(name)) {
      setError = "AppVersion";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        "Value should be without space";
    }

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  return (
    <>
      <Main active={"appversion_master"} removeContainer={true}>
        <Loadspinner filename="AppVersionMasterEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "5px" }}>Master</h4>
              </div>
              <div className="clearfix"></div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8">App Version</div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">App Version</label> */}
                      <FormLabel value="App Version"></FormLabel>
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"App Version"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={name}
                        onChange={(e) => handleTextEvent(e, "name")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["AppVersion_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["AppVersion_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Update Type</label> */}
                      <FormLabel value="Update Type"></FormLabel>
                      <InputForm
                        className="form-control form-control-sm"
                        isDisabled={true}
                        textArea={false}
                        value={"Force"}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Active Status</label> */}
                      <FormLabel value="Active Status" />
                      <div className="custom-checkbox">
                        <input
                          disabled={editModeIsActive ? true : false}
                          type="checkbox"
                          onChange={(e) => setIsActive(e.target.checked)}
                          name="isActive"
                          checked={isActive}
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <SubmitButton onClick={(e) => onClickFunction(e, "Submit")} />
                      {editModeDisableButton && (
                        <ResetButton onClick={(e) => onClickFunction(e, "Reset")} />
                      )}
                      <CancelButton onClick={(e) => onClickFunction(e, "Cancel")} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  );
};

export default AppVersionMasterEdit;
